import Vue from 'vue';
import Vuex from 'vuex';
import * as actions from './actions';
import * as getters from './getters';
import * as mutations from './mutations';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        breakpoints: {
            tabletLandscape: 980,
        },
        isMobileNav: false,
        apiUrl:
            window.location.host.indexOf('localhost') >= 0
                ? process.env.VUE_APP_APIBASE
                : window.location.protocol +
                  '//' +
                  window.location.host +
                  '/api/v1/',
        dimmed: false,
        locked: false,
        scrollPos: {},
        token: null,
        user: null,
        trees: [],
        activeTree: {},
        manipulatedData: {},
        organisation: null,
    },
    mutations,
    actions,
    getters,
    modules: {},
});
